import { useSearchParams } from 'react-router-dom';

import { useDetailsPlotGroup, usePlotGroupContext, usePlotGroupNames } from '../PlotGroupsContextProvider';
import { useSetPlotGroupWithoutGrouping } from './useSetPlotGroup';

export const useRemoveDetailsPlotGroup = () => {
  const { setPlotGroups, plotGroups } = usePlotGroupContext();
  const { DETAILS, DEFAULT } = usePlotGroupNames();
  const detailPlotGroup = useDetailsPlotGroup();

  const [searchParams, setSearchParams] = useSearchParams();
  const queryParamPlotGroupId = searchParams.get('plotGroupId');

  const { setPlotGroupWithoutGrouping } = useSetPlotGroupWithoutGrouping();

  /**
   * Updates the plot groups in the context provider to remove the details plot group and
   * activates the default plot group. If the details plot group is in the query params, it
   * removes it and replaces it with the default plot group id. Finally, it updates the no_grouping
   * plot group to replicate the filters in the default plot group (so that the details filters are
   * also cleaned from the no_grouping group)
   */
  const removeDetailsPlotGroup = () => {
    if (!detailPlotGroup.id) {
      return;
    }

    const isDetailsPlotGroupActive = detailPlotGroup.active;

    setPlotGroups((prev) => {
      return prev
        .filter((pg) => pg.name !== DETAILS)
        .map((pg) => {
          if (pg.name === DEFAULT && isDetailsPlotGroupActive) {
            return { ...pg, active: true };
          }

          return { ...pg, active: false };
        });
    });

    const defaultPlotGroup = plotGroups.find((pg) => pg.name === DEFAULT);

    if (detailPlotGroup.id === queryParamPlotGroupId) {
      searchParams.delete('plotGroupId');
    }

    if (defaultPlotGroup) {
      searchParams.set('plotGroupId', defaultPlotGroup?.id ? defaultPlotGroup.id : '');
      setPlotGroupWithoutGrouping(defaultPlotGroup);
    }

    setSearchParams(searchParams);
  };

  return { removeDetailsPlotGroup };
};
